// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceLabel_root__19zQe","rootHasSpacing":"PriceLabel_rootHasSpacing__DEbkI","label":"PriceLabel_label__8x_jn"};